import type { SlotProps as InputOTPSlotProps, OTPInputProps } from "input-otp"

import * as React from "react"

import { cx } from "@iyk/ui"
import { OTPInput } from "input-otp"

const InputOTP = ({ className, children, ...props }: InputOTP.Props) => (
  <OTPInput
    autoFocus
    containerClassName={cx("flex items-center gap-2 overflow-hidden w-full", className)}
    render={(props) => (children ? children(props) : null)}
    {...props}
  />
)

const InputOTPGroup = ({ className, ...props }: InputOTP.GroupProps) => (
  <div className={cx("flex items-center w-full", className)} {...props} />
)

const InputOTPSlot = ({ char, hasFakeCaret, isActive, className, ...props }: InputOTP.SlotProps) => {
  return (
    <div
      className={cx(
        "relative flex size-9",
        "grow items-center justify-center",
        "border-y border-r border-gray-6 text-sm transition-all first:rounded-l-sm first:border-l last:rounded-r-sm",
        isActive && "z-10 ring-2 ring-offset-white ring-gray-3",
        className
      )}
      {...props}
    >
      {char}
      {hasFakeCaret && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="animate-caret-blink h-4 w-px bg-gray-12 duration-1000" />
        </div>
      )}
    </div>
  )
}

const InputOTPSeparator = (props: InputOTP.SeparatorProps) => (
  <div role="separator" {...props}>
    -
  </div>
)

namespace InputOTP {
  export type Props = Omit<OTPInputProps, "render" | "children"> & {
    children: OTPInputProps["render"]
  }
  export type GroupProps = React.ComponentProps<"div">
  export type SeparatorProps = React.ComponentProps<"div">
  export type SlotProps = React.ComponentProps<"div"> & InputOTPSlotProps
}

export { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot }
